export const commissionSummary = {
  commissionSummary: "  Commission Summary",
  search: "Search",
  from: "From",
  to: "To",
  accountName: "Account Name",
  username: "Username",
  winLoss: "Win/Loss",
  bet: "Bet",
  settle: "Settle",
  topup: "Topup",
  withdraw: "Withdraw",
  rtbDeposit: "RTB Deposit",
  rtbWithdraw: "RTB Withdraw",
  viewDetail: "VIEW DETAIL",
  details: "Details",
  commission: "Commission",
  startDate: "START DATE",
  endDate: "END DATE",
  close: "Close",
  viewUser: "View User",
  validBet: "Total Valid Bet",
};
